//
// Copyright (C) 2021 The Android Open Source Project
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// @generated by protoc-gen-es v2.7.0 with parameter "target=ts,import_extension=none"
// @generated from file android/hardware/automotive/vehicle/VehiclePropertyChangeMode.proto (package android.hardware.automotive.vehicle.proto, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file android/hardware/automotive/vehicle/VehiclePropertyChangeMode.proto.
 */
export const file_android_hardware_automotive_vehicle_VehiclePropertyChangeMode: GenFile = /*@__PURE__*/
  fileDesc("CkNhbmRyb2lkL2hhcmR3YXJlL2F1dG9tb3RpdmUvdmVoaWNsZS9WZWhpY2xlUHJvcGVydHlDaGFuZ2VNb2RlLnByb3RvEilhbmRyb2lkLmhhcmR3YXJlLmF1dG9tb3RpdmUudmVoaWNsZS5wcm90bypGChlWZWhpY2xlUHJvcGVydHlDaGFuZ2VNb2RlEgoKBlNUQVRJQxAAEg0KCU9OX0NIQU5HRRABEg4KCkNPTlRJTlVPVVMQAmIGcHJvdG8z");

/**
 * Must be in sync with VehiclePropertyChangeMode.aidl. 
 *
 * @generated from enum android.hardware.automotive.vehicle.proto.VehiclePropertyChangeMode
 */
export enum VehiclePropertyChangeMode {
  /**
   * Property of this type must never be changed. Subscription is not supported
   * for these properties. 
   *
   * @generated from enum value: STATIC = 0;
   */
  STATIC = 0,

  /**
   * Properties of this type must report when there is a change.
   * IVehicle#get call must return the current value.
   * Set operation for this property is assumed to be asynchronous. When the
   * property is read (using IVehicle#get) after IVehicle#set, it may still
   * return old value until underlying H/W backing this property has actually
   * changed the state. Once state is changed, the property must dispatch
   * changed value as event. 
   *
   * @generated from enum value: ON_CHANGE = 1;
   */
  ON_CHANGE = 1,

  /**
   * Properties of this type change continuously and require a fixed rate of
   * sampling to retrieve the data.  Implementers may choose to send extra
   * notifications on significant value changes. 
   *
   * @generated from enum value: CONTINUOUS = 2;
   */
  CONTINUOUS = 2,
}

/**
 * Describes the enum android.hardware.automotive.vehicle.proto.VehiclePropertyChangeMode.
 */
export const VehiclePropertyChangeModeSchema: GenEnum<VehiclePropertyChangeMode> = /*@__PURE__*/
  enumDesc(file_android_hardware_automotive_vehicle_VehiclePropertyChangeMode, 0);

